/**
 * Sidebar Nav mobile dropdown — click-toggle handler.
 *
 * blocks/sidebar-nav.liquid renders a standalone trigger + expand
 * panel on mobile (≤767px), cloned structurally from the Collection
 * Menu section. Clicking the trigger toggles `.is-open` on the
 * wrapper (`.sidebar-nav__mobile`) and mirrors the state via the
 * trigger's `aria-expanded` attribute — the CSS keys off `.is-open`
 * for the grid-rows expand, chevron rotate, and label opacity fade.
 *
 * Uses a single document-level delegated click listener rather than
 * per-block bindings — the block can appear multiple times on a
 * page (e.g. two Sidebar Nav instances in different content columns)
 * without any risk of double-binding, and the customizer's dynamic
 * section reloads add no orphan listeners. Any element that matches
 * `[data-sidebar-nav-mobile-trigger]` at click time — whether it
 * was in the DOM at page load or injected later — is picked up.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('[data-sidebar-nav-mobile-trigger]');
  if (!trigger) return;

  const root = trigger.closest('[data-sidebar-nav-mobile]');
  if (!root) return;

  const isOpen = root.classList.toggle('is-open');
  trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});
